import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import vuetify from './plugins/vuetify';
import router from './routes/routes'
import axios from 'axios';
import store from './vuex/store.js';
import * as dateutils from './DateTimeUtils.js'
require('./css/style.css');
import moment from 'moment-timezone';
import firebase from 'firebase/app'
import 'firebase/messaging';


Vue.config.productionTip = false

// Prototypes
Vue.prototype.axios = axios;
Vue.prototype.moment = moment;
Vue.prototype.dateutils = dateutils;
Vue.use(VueRouter);

var firebaseConfig = {
    apiKey: "AIzaSyA4qnZ2CAVviZ9YVKIoWsSC2tYcFSRODZw",
    authDomain: "healthyalways-7591a.firebaseapp.com",
    databaseURL: "https://healthyalways-7591a.firebaseio.com",
    projectId: "healthyalways-7591a",
    storageBucket: "healthyalways-7591a.appspot.com",
    messagingSenderId: "959165512443",
    appId: "1:959165512443:web:a2b0306e41c831c93f4e5e"
  };

try{
    firebase.initializeApp(firebaseConfig)
    window.firebase_messaging = firebase.messaging()
}
catch(e){
    console.log("n")
}


window.subscribeToken =  function subscribeToken(){

    try{
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
              console.log('Notification permission granted.');
              let userInfo = JSON.parse(localStorage.getItem('userInfo'))
                if(userInfo){
                    window.firebase_messaging.getToken().then(async (token) => {
                        console.log(token)
                        if (token) {
                            axios.post(`${process.env.VUE_APP_API_URL}/api/patients/notifications/subscribe`,{
                                token:token
                            })
                            .then(() => {
                            })
                            .catch((error) => {
                                console.log(error)
                            })
                        } else {
                            console.log('No Instance ID token available. Request permission to generate one.');
                            this.notificationsPermisionRequest();
                        }
                    }).catch(function(err) {
                        console.log('An error occurred while retrieving token. ', err);
                    });
                }

            } else {
              console.log('Unable to get permission to notify.');
            }
          });
    }
    catch(e){
        console.log("n")
    }

}

window.deleteToken = function deleteToken() {

    try{
        
        window.firebase_messaging.getToken().then((token) => {

            if (token) {
                axios.post(`${process.env.VUE_APP_API_URL}/api/patients/notifications/unsubscribe`,{
                    token:token
                })
                .then(() => {
                })
                .catch((error) => {
                    console.log(error)
                })
            }

            // window.firebase_messaging.deleteToken(currentToken).then(() => {
            //   console.log('Token deleted.');
            // }).catch((err) => {
            //   console.log('Unable to delete token. ', err);
            // });

          }).catch((err) => {
            console.log('Error retrieving registration token. ', err);
          });
    }
    catch(e){
        console.log("n")
    }

}


import { ValidationProvider, ValidationObserver, setInteractionMode, extend } from 'vee-validate';
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
setInteractionMode('eager');

import * as rules from 'vee-validate/dist/rules';

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});
extend('required', {
    message: '{_field_} is required'
})
extend('length', {
    message: '{_field_} must be {length} characters long'
})
extend('min', {
    message: '{_field_} must be at least {length} characters long'
})
extend('max', {
    message: '{_field_} must be at most {length} characters long'
})
extend('size', {
    message: '{_field_} must be less than {size} kb'
})


axios.interceptors.response.use(null, function(error) {
    switch(error.response.status) {
        case 401:
            store.dispatch('userLogout').then(() => {                
                
                var newURL = new URL(`${process.env.VUE_APP_WEBSITE_URL}/patient-login`)                                
                    newURL.searchParams.set('redirect', window.location.href);                            
                    window.deleteToken()
                window.location.href = newURL.href

            })
            break
        case 403:
            //
            break
        case 404:
            //
            break
        case 422:
            
            for(let i in error.response.data.errors) {
                store.commit('showSnackbar', {message: error.response.data.errors[i][0]})
            }
            break
        case 429:
            //
            break
        default:
            // store.commit('showSnackbar', {message: 'Something went wrong, please contact the administrator', color: 'primary'})
            break
    }
    return Promise.reject(error)
})

// Mixins
Vue.mixin({
    methods: {
        getSlugFromString(inputString) {
            return inputString.replace(/ /g,"-").replace(/[&/\\#,+()$~%@^'"!:*?<>{}]/g, '');
        },
        goToWebsite(url, newTab = true) {
            let websiteUrl = process.env.VUE_APP_WEBSITE_URL;

            if (url.length) {
                websiteUrl += '/' + url;
            }
            if (newTab) {
                window.open(websiteUrl, "_blank");
            } else {
                window.location.href = websiteUrl;
            }
        }
        
    }
});

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
